<template>
    <div class="table_wrap">
        <div class="sub_title">총 {{ paginationData.total }}건</div>
        
        <el-table class="list-table" header-cell-class-name="list-header" :data="couponData"
                  style="width: 100%;" height="695" empty-text="데이터가 없습니다.">
            <el-table-column
                class="table_no"
                type="index"
                label="No"
                min-width="70"
                class-name="num text-center"
                :index="tableIdx"
            >
            </el-table-column>
            <el-table-column label="쿠폰명" width="" class-name="text-center" prop="c_name_ko"></el-table-column>
            <el-table-column label="지급 KOIN" width="" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{scope.row.c_benefit}} KOIN
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="발급개수" width="" class-name="text-center" prop="c_count"></el-table-column>
            <el-table-column label="사용개수" width="" class-name="text-center" prop="useCnt"></el-table-column>
            <el-table-column label="사용기간" min-width="" class-name="text-center" prop="c_period_date"></el-table-column> 
            <el-table-column
                label="발급일" min-width="" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{returnDateUnix(scope.row.created_at, 'YYYY-MM-DD HH:mm')}}
                    </span>
                </template>
            </el-table-column> 
            <el-table-column label="옵션" min-width="70" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info">
                        <el-button @click="goDetail(scope.row.c_idx)">
                            상세
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import util from "@/mixins/util";
    import EventBus from "@/utils/event-bus";
    import dateMixins from "@/mixins/dateMixins";
    import {appLanguage} from "@/service/languageService";

    export default {
        name: "CouponListDefaultLayout",
        mixins: [dateMixins],
        inject: ['couponListSetData'],
        components: {},
        provide() {
            return {}
        },
        props: {
            couponData: {default: () => []},
            paginationData: {
                default: () => { return { total: 0, page: 0, size: 0, }}
            },
        },
        data() {
            return {
                selectArr: [],
                languages : appLanguage
            }
        },
        created() {},
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods: {
            tableIdx(index) {
                return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
            },
            goDetail(idx) {
                this.$router.push(`/payment/coupon/${idx}`);
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>